<template>
  <b-modal size="lg" id="modalResponsible" hide-footer hide-header>
    <div class="summaryForm">
      <button class="closeModal" @click="$bvModal.hide('modalResponsible')">
        <b-icon-x scale="1.3"></b-icon-x>
      </button>

      <div>
        <Responsible
          :isFixed="false"
          @getAllResponsibles="getAllResponsibles"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Responsible from "../Responsible/Responsible.vue";

export default {
  props: {},
  components: {
    Responsible,
  },
  data() {
    return {};
  },

  methods: {
    getAllResponsibles() {
      this.$emit("getAllResponsibles");
    },
  },
  watch: {},
  mounted() {},
  computed: {},
  beforeDestroy() {},
};
</script>

<style scoped>
.summaryForm {
  display: flex;
  flex-direction: column;
  color: #006256;
}

.summaryForm label {
  margin-bottom: 0px;
  font-weight: bold;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}
</style>